module.exports = __webpack_public_path__ + "static/media/profile.0f7db65a.svg";